import { type BackendConfigJson } from './backendConfigJsonSchema';

export const localhostDefaultConfig: BackendConfigJson = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  AzureAdClientId: import.meta.env.VITE_APP_AZURE_AD_CLIENT_ID ?? '77c77ea6-1f7d-470c-85eb-10fdf813846e',
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  AzureAdTenantId: import.meta.env.VITE_APP_AZURE_AD_TENANT_ID ?? '88d0a5a9-d61a-4dd6-9a75-6637f3fe6bd8',
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  AzureAdRedirectUri: import.meta.env.VITE_APP_AZURE_AD_REDIRECT_URI ?? 'https://va.vamos.ban.akadev.de/auth/redirect',
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  BackendUrl: import.meta.env.VITE_SAP_ADAPTER_BACKEND_URL ?? 'http://localhost:4444/api/',
  Stage: 'local',
};
